import { styled } from '@styles/stitches';

export const Trigger = styled('div', {
  backgroundColor: 'transparent',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '&:focus': { outline: 'none' },
});

export const Content = styled('div', {
  minWidth: 150,
  backgroundColor: '$primaryBackground',
  borderRadius: 5,
  overflow: 'hidden',
  border: '1px solid $colors$primaryBorder',
  boxShadow: '0px 5px 15px -5px hsla(206,22%,7%,.15)',
});

export const Item = styled('div', {
  padding: '8px 16px',
  borderRadius: 2,
  cursor: 'pointer',
  color: '$secondaryFill',
  fontSize: 16,

  '@bp1': {
    fontSize: 14,
  },

  '&:focus': {
    outline: 'none',
    backgroundColor: '$secondaryBackground',
    color: '$primaryFill',
  },
});

export const Separator = styled('div', {
  height: '1px',
  backgroundColor: '$colors$primaryBorder',
});
